import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormField from './../FormField';
import CategoryField from './../CategoryField';
import FieldsArray from './../FieldsArray';
import CategoryFieldset from './CategoryFieldset';
import CategoryPricingTierInfo from './../../CategoryPricingTierInfo';
import { formValues } from 'redux-form';
import allCategories from 'lib/categoriesMapper';
import max from 'lodash/max';
import TitleHeader from '../../TitleHeader';

const AdditionalCategories = ({ config, categories, maxPricingTier, pricingTiers, currentPricingTier }) => {
  return (
    <div className="row">
      <div className="col">
        <FieldsArray
          name="sub_categories"
          component={CategoryFieldset}
          componentProps={{config, categories, maxPricingTier, pricingTiers, currentPricingTier}}
          resourceName="another category"
          max={2}
          additionalActionClassName="col-lg-8"
          additionalActionVisibleWithButton={true}
          additionalAction={
            <span>
              <strong>*Premium Feature</strong> - Select up to 3 categories to increase the coverage of your event promotion.<br/>
              <strong><a href={config.get('categories_url')}>Download the full category tree & price plan</a></strong>
            </span>
          }
        />
      </div>
    </div>
  );
};

AdditionalCategories.propTypes = {
  config: ImmutablePropTypes.map,
  categories: PropTypes.array,
  maxPricingTier: PropTypes.number,
  pricingTiers: ImmutablePropTypes.map.isRequired,
  currentPricingTier: PropTypes.number,
};


const BasicsFieldset = formValues({
  required_pricing_tier_level: 'required_pricing_tier_level',
  category_id: 'category_id', sub_categories: 'sub_categories'
})(({
  formErrors, categories, config, currentUser, pricingTiers, required_pricing_tier_level,
  category_id, sub_categories
}) => {
  let maxPricingTier = null;
  const currentCategories = allCategories(category_id, sub_categories, categories);
  const currentPricingTier = max(currentCategories.map((el) => el.pricing_tier_level));
  if (currentUser && !currentUser.isEmpty()) {
    const userPricingTiers = currentUser.get('available_pricing_tiers');
    if (userPricingTiers && !userPricingTiers.isEmpty()) {
      maxPricingTier = userPricingTiers.max();
    }
  }

  if (config.get('premium_edit') && required_pricing_tier_level) {
    maxPricingTier = required_pricing_tier_level;
  }

  return (
    <div className="BasicsFieldset">
      <div className="row">
        <div className="col-12">
          <FormField
            error={formErrors.get('title')}
            name="title"
            component="input"
            type="text"
            className="form-control"
            placeholder="The name of your event"
            maxLength={100}
            normalize={val => val.substr(0, 100)}
            onFocusTip="Enter an eye catching name for your event, including the date & location for additional SEO benefits"
            required
            clearMargin={true}
            infoUrl="https://support.evvnt.com/hc/en-us/articles/216643308-Basics-Creating-your-event-title-"
          />
        </div>
      </div>
      <TitleHeader title="Event Category" infoUrl="https://support.evvnt.com/hc/en-us/articles/360020920793-Basics-Choosing-your-categories" containerClass="m-0 mb-4" required/>
      <div className="row">
        <div className="col-12">
          <FormField
            name="category_id"
            error={formErrors.get('category_id')}
            component={CategoryField}
            inputProps={{ valueField: 'id', textField: 'name_with_path', clearable: true, allowModalPreopening: true }}
            config={config}
            placeholder="Search for a category by name or keyword - submit to all plans for free."
            categories={categories}
            maxPricingTier={maxPricingTier}
            currentPricingTier={currentPricingTier}
            pricingTiers={pricingTiers}
            type="text"
            className="form-control"
            algolia-autocomplete
          />
        </div>
      </div>
      <AdditionalCategories
        categories={categories}
        config={config}
        maxPricingTier={maxPricingTier}
        pricingTiers={pricingTiers}
        currentPricingTier={currentPricingTier}
      />
      <CategoryPricingTierInfo categories={categories} currentUser={currentUser} maxPricingTier={maxPricingTier}/>
    </div>
  );
});

BasicsFieldset.propTypes = {
  formErrors: PropTypes.object,
  categories: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  currentUser: ImmutablePropTypes.map,
  pricingTiers: ImmutablePropTypes.map.isRequired,
  category_id: PropTypes.number,
  sub_categories: PropTypes.object,
};

export default BasicsFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/BasicsFieldset.jsx